import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronLeftDouble16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M8.53044 3.53033L7.46978 2.46967L1.93945 8L7.46978 13.5303L8.53044 12.4697L4.06077 8L8.53044 3.53033Z'
      fill='currentColor'
    />
    <path
      d='M13.5304 3.53033L12.4698 2.46967L6.93945 8L12.4698 13.5303L13.5304 12.4697L9.06077 8L13.5304 3.53033Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronLeftDouble16.displayName = 'ChevronLeftDouble16';
export default ChevronLeftDouble16;
